import React, { Component, Fragment } from "react";
import "./profile.css";
import Auth from "../../services/authService";
import LoadingSpinner from "../../components/loader/LoadingSpinner";
import { toast } from "react-toastify";
import UserProfileService from "../../services/userProfileService";
import { Link } from "react-router-dom";

const user = Auth.getCurrentUser();

export default class purchases extends Component {

    state = {
        isLoading: false,
        WarrantyInquiryIsLoading: false,
        UserProductionOrderItems: [],
        userProductionOrderCount: 0
    };

    async componentDidMount() {
        if (Auth.getCurrentUser()) {
            try {
                const result =
                    await UserProfileService.getUserHmaUserProductionOrderItems(
                        user.nameid
                    );
                this.setState({ UserProductionOrderItems: result.data });
                this.setState({ userProductionOrderCount: result.data.length });
                const isLoading = true;
                this.setState({ isLoading });
                console.log("result : ", result);
            } catch (ex) {
                if (ex.code !== "ERR_NETWORK" && ex.code !== "ERR_BAD_REQUEST") {
                    toast.error(ex.response.data.Message);
                }
            }
        }
    }

    handleRedirect(item) {
        this.props.push("/deviceStatus", {
            id: item.id,
            title: item.productionName,
            modelTitle: item.modelTitle,
            productionCode: item.productionCode,
            serial: item.serial,
            deliverDate: item.deliverDate,
            imageUrl: item.ImageUrl,
            codingTitle: item.CodingTitle
        });
    }

    render() {
        return (
            <div className="row hrow">
                {this.state.isLoading ? (
                    <section className="innerSection">
                        {this.state.userProductionOrderCount == "0" &&
                            <section className="container">
                                <div className="hrh_resultNotFound">
                                    <span>دستگاهی برای نمایش وجود ندارد</span>
                                </div>
                            </section>
                        }
                        {this.state.UserProductionOrderItems.map((item) => (
                            <div key={item.id}>
                                <Link to={"/deviceStatus"} state={{
                                    id: item.id,
                                    title: item.productionName,
                                    modelTitle: item.ModelTitle,
                                    productionCode: item.productionCode,
                                    serial: item.serial,
                                    deliverDate: item.deliverDate,
                                    imageUrl: item.ImageUrl,
                                    codingTitle: item.CodingTitle
                                }} >
                                    {item.CodingTitle === "محصولات | کمپرسور Compressor " &&
                                        <div className="productitme">
                                            <div className="DeviceTypeIcon D01"></div>
                                            <h3 className="DeviceName">{item.productionName}
                                                <a />
                                            </h3>
                                            <h3 className="DeviceType">مدل: {item.modelTitle}</h3>
                                            <h3 className="DeviceType">سریال:  <span>{item.serial}</span></h3>
                                            {/*<h3 className="DeviceType">آخرین ساعت کارکرد:  <span>{item.serial}</span></h3>*/}
                                            {/*<h3 className="DeviceType">تاریخ سرویس قبلی:  <span>{item.serial}</span></h3>*/}
                                            {/*<h3 className="DeviceType">تاریخ سرویس بعدی:  <span>{item.serial}</span></h3>*/}
                                        </div>
                                    }
                                    {item.CodingTitle !== "محصولات | کمپرسور Compressor " && item.serial !== null &&
                                        <div className="productitme">
                                            <div className="DeviceTypeIcon D01"></div>
                                            <h3 className="DeviceName">{item.productionName}
                                                <a />
                                            </h3>
                                            <h3 className="DeviceType">مدل: {item.modelTitle}</h3>
                                            <h3 className="DeviceType">سریال:  <span>{item.serial}</span></h3>
                                        </div>
                                    }
                                    {item.CodingTitle !== "محصولات | کمپرسور Compressor " &&  item.serial === null &&
                                        <div className="productitme">
                                            <div className="DeviceTypeIcon D01"></div>
                                            <h3 className="DeviceName">{item.productionName}
                                                <a />
                                            </h3>
                                            <h3 className="DeviceType">مدل: {item.modelTitle}</h3>
                                        </div>
                                    }
                                </Link>
                            </div>
                        ))}
                    </section>) : (<LoadingSpinner />)}
            </div>
        );
    }
}
